import {connect} from "react-redux";
import SiteVisitView from "./View";
import {bindActionCreators} from "redux";
import {viewActivity} from "../../../../service/Activity/action";

const mapStateToProps = (state) => ({
    activityByIdDetails:state.Activity.activityByIdDetails,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            viewActivity
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(SiteVisitView);
